import GalleryContainerCard from './GalleryContainerCard.component';

export default GalleryContainerCard;